import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {Location} from '@angular/common';
import {auditTime, debounceTime, delay, filter, finalize, share} from 'rxjs/operators';
import {Subject, Subscription, timer} from 'rxjs';

import {JASO} from '../shared/defines/gukeo.const';
import {
  generateUrlWithQueryParams,
  getDetailHeight,
  GetSearchFromQuery,
  scrollToNode
} from '../shared/defines/client.func';
import {
  CONTAINER_SCROLL_DELAY,
  DETAIL_POPUP_DELAY,
  HISTORY_KEY_SEARCH_WORD,
  LIST_TYPE,
  REPLACE_URL_AUDIT_TIME,
  SCROLL_DEBOUNCE_TIME,
  SearchParam,
  triggerDetailPopup,
  UI_RELOAD_HEIGHT, WORD_DETAIL_HEIGHT_DELTA, WORD_DETAIL_HEIGHT_DELTA_LARGE,
  WORD_SCROLL_SPEED,
  wordSelectId
} from '../shared/defines/client.const';
import {STAR_FILTER} from "../shared/defines/protocol";
import {IsEqualObj1} from '../shared/defines/common.func';
import {NormalizeSearchParamKeyword} from '../shared/defines/search-keyword.func';
import {SimpleWord} from '../shared/models/simple-word.model';
import {Word} from '../shared/models/word.model';
import {ListLoader} from '../shared/interfaces/list-loader';
import {WordService} from '../shared/services/word/word.service';
import {WordBookmarkService} from '../shared/services/word/word-bookmark.service';
import {WordHistoryService} from '../shared/services/word/word-history.service';
import {OptionService} from '../shared/services/option/option.service';
import {LayoutMgrService} from '../shared/services/layout-mgr/layout-mgr.service';
import {VoiceService} from '../shared/services/voice/voice.service';
import {ResizeService} from '../shared/services/resize/resize.service';
import {GlobalEventService} from "../shared/services/global-event/global-event.service";
import {ScrollDownService} from "../shared/services/scroll-down/scroll-down.service";
import {LastIdService} from "../shared/services/last-id/last-id.service";
import {WordListHelpComponent} from './word-list-help/word-list-help.component';
import {HeaderComponent} from "../shared/components/header/header.component";
import {FOOTER_ON, FooterComponent} from '../shared/components/footer/footer.component';
// import _ from 'lodash';
// import * as _ from 'lodash';

@Component({
  selector: 'app-word',
  templateUrl: './word.component.html',
  styleUrls: ['./word.component.scss'],
  animations: [triggerDetailPopup],
})
export class WordComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild(WordListHelpComponent) listHelp: WordListHelpComponent;
  @ViewChild(FooterComponent) footer: FooterComponent;
  @ViewChild('reload') reload: ElementRef;

  Array = Array;
  wordSelectId = wordSelectId;

  private inited = false;
  private type: LIST_TYPE = null;

  // 라우터에서 넣어주는 값. (초기화에 유의해야 함)
  private queryParams: SearchParam = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;
  private route$: Subscription = null;

  // 해더에 넣는 값
  public curJasoIdx: JASO | null = null;
  public keyword: string = null;
  public placeholder = '단어를 검색 합니다.';
  public HistoryKeySearchWord = HISTORY_KEY_SEARCH_WORD;

  public jasoIdxSecond = true;
  protected thisPageAddr = '/word';
  protected modParam(param: SearchParam): SearchParam {
    return param;
  }
  protected setLastId(detail_id: string | null, list_id: string | null) {
    this.lastIdSvc.setLastWordId(detail_id, list_id);
  }
  protected clearLastId() {
    this.lastIdSvc.clearLastWordId();
  }

  protected noResultTxt = '단어가 없습니다.';

  // ListLoader 설정
  public ll: ListLoader<SimpleWord>;
  public get isModeServer() {
    return this.type === LIST_TYPE.SERVER;
  }
  public get isModeBookmark() {
    return this.type === LIST_TYPE.BOOKMARK;
  }

  // 상세화면 표시 관련 정의
  public showDetail = false;
  public curDetail: SimpleWord = null; // 현재 선택된 단어
  private oldScrollTop: number;
  public detailHeight: number = 0;         // 상세 팝업창 세로 크기
  private get deltaHeight() {
    // return this.option.largeMode ? WORD_DETAIL_HEIGHT_DELTA_LARGE : WORD_DETAIL_HEIGHT_DELTA;
    return WORD_DETAIL_HEIGHT_DELTA;
  }

  private getNextList$: Subscription = null;
  private needReload = false;

  // 사투리 지도 팝업창 처리
  public showDialectMap = false;
  protected curWord: Word = null; // 주의: curDetail 과 다른 용도

  // 화면 크기 변경
  private resize$: Subscription = null;

  // 라우팅 처리
  private router$?: Subscription | null = null;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  // 라우팅 컨트롤 변수
  private scrollEvent$: Subject<void>;
  private scrollEvent$$: Subscription;
  private replaceUrl$: Subject<string>;
  private replaceUrl$$: Subscription;

  protected showLevel = true;

  protected isOptionWordLevelAll() {
    return this.option.wordLevel === STAR_FILTER.ALL;
  }

  // 코르도바 상태
  cordova: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private voice: VoiceService,
    private option: OptionService,
    private wordSvc: WordService,
    private bmSvc: WordBookmarkService,
    private historySvc: WordHistoryService,
    protected lastIdSvc: LastIdService,
    private globalEventSvc: GlobalEventService,
    private scrollDownSvc: ScrollDownService,
    public lm: LayoutMgrService,
    private resizeSvc: ResizeService,
  ) {
    // console.warn('# WordComponent::constructor');

    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.routeParams$ = this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        const oldParams = {...this.queryParams};
        this.queryParams = NormalizeSearchParamKeyword({...params});
        delete this.queryParams.serial;
        console.log('WordComponent::queryParams =', this.type, params, this.queryParams);

        this.type = this.queryParams?.l ?? LIST_TYPE.SERVER;

        if (this.inited) {  // 이미 화면이 초기화되어있는 경우!

          // 현재 목록에서 지정한 단어 항목이 존재하는지 확인
          if ('id' in this.queryParams) {

            const processParams = () => {
              const word = this.ll.getById(this.queryParams.id) ?? null;
              console.log('queryParams:: word=', word);
              if (word) {
                // 현재 상세 팝업창을 닫고, 새로운 단어로 다시 연다.
                this.CloseDetail();
                setTimeout(() => {
                  this.OpenDetail(word);
                }, DETAIL_POPUP_DELAY);
              }
              else {
                // 존재하지 않으면, 해당 단어를 시작으로 로딩한다.
                console.warn('does not exist word', this.queryParams.id);
                this.init();
              }
            };

            if (this.ll.IsLoading()) {
              // 이 시점에서 아직 목록 로딩이 안 끝났을 수 있다.
              this.ll.GetNextList().pipe(
                delay(DETAIL_POPUP_DELAY),
              ).subscribe(processParams);
            }
            else {
              processParams();
            }
          }
          else {
            // id 가 없는 경우

            const params = {...oldParams}
            delete params.id;
            if (IsEqualObj1(params, this.queryParams)) {
              // 기존의 값과 id 만 차이 난다면, 현재 상세 팝업창을 닫는다.
              this.CloseDetail();
            }
            else {
              // 기존의 파라미터와 다르면, 다시 로딩한다.
              this.init();
            }
          }
        }
      });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.route$ = route.params.subscribe(params => {
      console.log('params =', params, this.queryParams);

      this.inited = true;

      this.init();
    });

    this.resetScroll();

    this.lm.Reset();
  }

  ngOnInit(): void {
    // TODO: 이 부분은 좀 더 정밀하게 할 필요가 있다. 내 컴포넌트(WordComponent)인 경우에만 처리하도록 수정할 필요가 있다.
    this.router$ = this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
    ).subscribe((event) => {

      // base url이 변경될 때만 호출
      const curBasePath = this.router.url.split('?')[0]; // 현재의 base url
      const tarBasePath = (event as NavigationStart).url.split('?')[0]; // 이동할 base url
      if (curBasePath !== tarBasePath) {
        this.onLeave();
      }
    });

    // PopStateEvent 감지 - 뒤로간 뒤에 불려져서 페이지가 바뀌어버린다.
    // this.location.subscribe((popStateEvent) => {
    //   if (popStateEvent.type === 'popstate') {
    //     this.onLeave();
    //   }
    // });

    // console.warn('# WordComponent::ngOnInit');
    this.resize$ = this.resizeSvc.screenHeight$.subscribe(height => {
      console.log('resize::height = ', height);
      if (this.showDetail) {
        const elContainer = this.container.nativeElement;
        const el = document.getElementById(wordSelectId(this.curDetail));
        this.detailHeight = getDetailHeight(elContainer, el, this.footer.height + this.deltaHeight);
      }
    });

    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      // console.warn('scrollDown$', this.showDetail, isFirst);

      if (isFirst) {
        this.onCloseItem();
      }

      const scrollDelta = WORD_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      // console.warn('scrollDown$ scrollDelta =', scrollDelta, isFirst, this.container, this.container?.nativeElement.scrollTop, this.container?.nativeElement.scrollHeight);

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });
  }


  ngOnDestroy(): void {
    // console.warn('# WordComponent::ngOnDestroy');

    if (this.getNextList$) {
      this.getNextList$.unsubscribe();
      this.getNextList$ = null;
    }
    if (this.router$) {
      this.router$.unsubscribe();
      this.router$ = null;
    }
    if (this.resize$) {
      this.resize$.unsubscribe();
      this.resize$ = null;
    }
    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }
    if (this.route$) {
      this.route$.unsubscribe();
      this.route$ = null;
    }
    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
      this.scrollEvent$$ = null;
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
      this.replaceUrl$$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }

    if (this.showDetail) this.CloseDetail();
  }

  public onGoHistory(): void {
    // 사용하지 않음
    // this.type = LIST_TYPE.HISTORY;
    // this.queryParams = {};
    // this.setHistory({}, false, false);
  }

  public GetFooterOn(): FOOTER_ON {
    return this.ll instanceof WordBookmarkService ? FOOTER_ON.BOOKMARK : FOOTER_ON.NONE;
  }

  private resetParams(): void {
    this.curDetail = null;
    this.curJasoIdx = null;
    this.keyword = null;
  }

  /**
   * 저장된 searchParam(라우팅에서 전달받은 옵션)을 이용해서 페이지를 재 초기화하고 다시 로딩한다.
   */
  private init(): void {
    console.log('WordComponent::init()', this.type, this.queryParams);

    if (this.curDetail) {
      this.CloseDetail();
    }

    let param: SearchParam;
    switch (this.type) {
      case LIST_TYPE.SERVER:
        this.ll = this.wordSvc;
        // this.placeholder = '단어를 검색 합니다';
        [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);

        // 라우터에서 단어를 지정했을 때 start 파라미터가 없으면 추가해준다.
        // 이렇게 안 하면 로딩된 데이터에 id 에 해당하는 단어가 존재하지 않을 수 있다.
        if (this.queryParams?.id && !this.queryParams.start) {
          param.start = this.queryParams.id;
        }

        if (this.queryParams?.hanja) {
          this.resetParams();
          param.hanja = this.queryParams.hanja
          // 음(hangul)은 한자(hanja)가 있을 때만 함께 전달하는 선택 옵션이다.
          if (this.queryParams?.hangul) {
            param.hangul = this.queryParams.hangul;
          }
        }

        this.ReloadList(param);
        break;
      case LIST_TYPE.BOOKMARK:
        this.ll = this.bmSvc;
        this.curJasoIdx = null;
        // this.placeholder = '단어를 검색 합니다.';
        [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);
        this.ReloadList(param);
        break;
      case LIST_TYPE.HISTORY:
        this.ll = this.historySvc;
        this.curJasoIdx = null;
        // this.placeholder = '단어를 검색 합니다.';
        // param = (this.queryParams && 'id' in this.queryParams) ? { id: this.queryParams.id } : {};
        param = (this.queryParams && 'start' in this.queryParams) ? {id: this.queryParams.start} : {};
        this.ReloadList(param);
        break;
      default:
        console.error('Invalid LIST_TYPE =', this.type);
    }
  }

  /**
   * 이 함수는 라우터의 base 주소가 변경될 때 불려진다.
   * @private
   */
  private onLeave(): void {
    console.warn('WordComponent::onLeave()', this.queryParams);

    if ('keyword' in this.queryParams || 'hanja' in this.queryParams) {  // 검색어나 hanja 파라미터가 있는 경우만 start를 붙임.
      this.clearLastId();
      return;
    }

    const top: SimpleWord = this.scrollTopTarget;
    if (!top) {
      this.clearLastId();
      return;
    }

    // start 파라미터는 id 보다 같거나 작아야 함.
    const top_id = (this.queryParams?.id && this.queryParams.id < top.id) ? this.queryParams.id : top.id;

    const queryParam: SearchParam = {
      ...(this.queryParams ? this.queryParams : {}),
      start: top_id,
    }
    const basePath = this.router.url.split('?')[0];  // query parameter를 제거
    const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
    console.warn('WordComponent::replaceUrl$ urlWithParams =', urlWithParams);

    // URL 변경
    this.location.replaceState(urlWithParams);

    this.setLastId(this.curDetail?.id ?? null, top_id);
  }

  /****************************************************************************
   * 단어 목록 로딩 처리.
   ****************************************************************************/
  public onSearch(params: SearchParam): void {
    // 단어 이력보기 화면에서 자소를 선택하면 단어 검색으로 변경한다.
    // if (this.ll instanceof WordHistoryService && ('index' in param || 'keyword' in param)) {
    //   console.warn('ReloadWordList:: ll, param', this.ll, param);
    //   this.router.navigate(['/word', LIST_TYPE.SERVER], {
    //     queryParams: {...param}
    //   }).then();
    //   return;
    // }
    //

    const queryParams: SearchParam = {
      ...NormalizeSearchParamKeyword(params),
      l: LIST_TYPE.SERVER,
    }
    this.router.navigate([this.thisPageAddr], {queryParams}).then();

    /**
     * 검색어가 변경되면, URL 변경 작업중인 것들을 중단한다.
     */
    this.resetScroll();

    // 마지막 단어 설정을 지운다.
    this.clearLastId();
  }

  public ReloadList(param: SearchParam): void {
    this.ll.ResetList({
      ...this.modParam(param),
      level: this.option.wordLevel
    });
    this.loadList(true);

    // 새 조건으로 목록을 재로딩할 때 목록 스크롤을 최상단으로 되돌린다. (#602)
    this.scrollListToTop();

    // if (this.showDetail) this.CloseDetail();
    // if (this.listHelp) this.listHelp.reset();
  }

  /**
   * 목록을 새로 로딩할 때 컨테이너 스크롤을 최상단(0)으로 되돌린다. (#602)
   *
   * iOS(Cordova) WKWebView 는 관성(momentum) 스크롤이 진행 중일 때 `scrollTop = 0`
   * 대입을 무시한다. 그래서 목록을 손가락으로 스크롤(=관성 활성)하다가 색인을 누르면,
   * 재로딩이 빠르게 끝나 관성이 아직 살아있는 경우 리셋이 덮여 이전 위치가 남는다.
   * (느린 재로딩은 관성이 끝난 뒤 리셋되어 정상. 웹·안드로이드는 관성이 프로그램적
   * 스크롤을 덮지 않아 정상 — iOS 실기기 원격 디버깅 측정으로 확인. #602)
   *
   * 대책: `overflow` 를 잠깐 `hidden` 으로 만들어(스크롤 영역 자체를 제거) 진행 중인
   * 관성을 끊고 최상단으로 고정한 뒤 원복한다. 이후 새 목록 렌더 타이밍 안전망으로
   * 한 번 더 확정한다. 전체 재로딩 경로(`init()` → `ReloadList()`)에서만 호출되므로
   * 상세 열기/닫기(`id` 변경)나 무한 스크롤 페이지네이션에는 영향을 주지 않는다.
   * @private
   */
  private scrollListToTop(): void {
    const el = this.container?.nativeElement;
    if (!el) {
      return;
    }
    // overflow 를 잠깐 없애 관성 스크롤을 끊고 최상단으로 고정한다. (iOS WKWebView 대응)
    const prevOverflowY = el.style.overflowY;
    el.style.overflowY = 'hidden';
    el.scrollTop = 0;
    void el.offsetHeight;              // 강제 reflow 로 관성 취소를 커밋
    el.style.overflowY = prevOverflowY;
    el.scrollTop = 0;

    // 새 목록 DOM 재렌더 이후에도 최상단을 유지한다. (렌더 타이밍 안전망)
    timer(0).subscribe(() => {
      const c = this.container?.nativeElement;
      if (c) {
        c.scrollTop = 0;
      }
    });
  }

  private loadList(cancel = false): void {
    if (this.getNextList$) {
      console.warn('WordComponent::loadList() already call loadList!');
      if (cancel) {
        this.getNextList$.unsubscribe();
      } else {
        return;
      }
    }

    if (this.ll.IsComplete()) {
      console.warn('WordComponent::loadList() already load all word!');
      return;
    }

    const sharedObservable$ = this.ll.GetNextList().pipe(share());

    this.getNextList$ = sharedObservable$.pipe(
      filter(ret => ret?.first),
      delay(DETAIL_POPUP_DELAY),
      finalize(() => {
        this.getNextList$ = null;
        if (this.needReload) {
          timer(0).subscribe(() => {
            this.needReload = false;
            this.loadList();
          });
        }
      })
    ).subscribe(data => {
      // console.warn('is Open?', {...this.queryParams});

      if (this.ll?.getList() === null || this.ll?.getList()[0]?.id === undefined) {
        // 목록이 없다면
      } else {
        // 목록이 있다면
        if (this.queryParams && 'id' in this.queryParams) {
          const word = this.ll.getById(this.queryParams.id);
          if (word) {
            this.OpenDetail(word);
          }
        }
      }
    });

    // 새로 항목이 로딩 된 뒤에, 주소를 변경한다.
    // sharedObservable$.pipe(
    //   delay(DETAIL_POPUP_DELAY),
    // ).subscribe(ret => {
    //   if (ret.list?.length > 0) {
    //     // 이전에 진행하던 작업을 모두 취소하고 다시 넣는다.
    //     this.resetScroll();
    //
    //     const firstItem = ret.list[0];
    //     this.replaceUrl$.next(firstItem.id);
    //   } else {
    //     console.log('ret.list is empty');
    //   }
    // });
  }

  /****************************************************************************
   * 일정 범위 이상 스크롤되면 남은 단어를 자동 로딩한다.
   ****************************************************************************/

  onScroll($event): void {

    if (!this.ll.IsLoading() && !this.ll.IsComplete()) {
      const tar = $event.target || $event.srcElement || $event.currentTarget;
      if (tar !== this.container.nativeElement) {
        console.error('WordComponent::onScroll() - wrong structure!!');
      }

      const elReload = this.reload.nativeElement;
      if (elReload.offsetTop < window.innerHeight + tar.scrollTop + UI_RELOAD_HEIGHT) {
        if (this.getNextList$ === null) {
          this.loadList();
        } else {
          // 스크롤 중에 이미 로딩이 진행되고 있으면, 로딩이 끝난 뒤에 다시 로딩이 되도록 요청. (비동기처리 순서 꼬임 방지)
          this.needReload = true;
        }
      }
    }

    if (!this.showDetail) {
      this.scrollEvent$.next();
    }
  }

  /**
   * 뒤로가기 할 때 현재의 화면 상태를 저장하기 위한 루틴
   * @private
   */
  private resetScroll(): void {
    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
    }

    this.scrollEvent$ = new Subject<void>();

    /**
     * 일정 시간 기다리는 동안 새로운 값이 들어오면 또 일정 시간을 다시 기다린다.
     * (새로운 값이 들어오면 대기 시간 연장)
     */
    this.scrollEvent$$ = this.scrollEvent$.pipe(
      debounceTime(SCROLL_DEBOUNCE_TIME)  // 1000ms 이내로 이벤트가 들어오면 이전 것을 무시
    ).subscribe(event => {
      console.warn('WordComponent::scrollEvent$');

      const top: SimpleWord = this.scrollTopTarget;
      if (top) {
        this.replaceUrl$.next(top.id);
      }
    });


    this.replaceUrl$ = new Subject<string>();

    /**
     * 일정 시간 동안 기다린 후, 최종 값을 사용함.
     * (새로운 값이 들어와도 대기 시간 연장 안함)
     */
    this.replaceUrl$$ = this.replaceUrl$.pipe(
      auditTime(REPLACE_URL_AUDIT_TIME),
      filter(() => !('keyword' in this.queryParams || 'hanja' in this.queryParams)),
    ).subscribe((id: string) => {
      const queryParam: SearchParam = {
        ...(this.queryParams ? this.queryParams : {}),
        start: id,
      }
      const basePath = this.router.url.split('?')[0];  // query parameter를 제거
      const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
      console.warn('WordComponent::replaceUrl$ urlWithParams =', urlWithParams);

      // URL 변경
      this.location.replaceState(urlWithParams);

      this.setLastId(this.curDetail?.id ?? null, id);
    });
  }


  /****************************************************************************
   * 단어 상세 팝업창 처리 코드
   ***************************************************************************/

  /**
   * 단어 목록에서 단어를 선택했을 때의 이벤트 처리 함수
   * 라우터 주소가 변경되어야하기 때문에 바로 OpenDetail()함수를 호출하지 않고 라우터를 통해서 OpenDetail()이 불려지도록 한다.
   * @param $event
   * @param word
   * @protected
   */
  protected onSelectItem($event: MouseEvent, word: SimpleWord): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event);

    // 이미 열려있으면 무시
    if (this.showDetail) {
      console.warn('onSelectItem() already opened!');
      return;
    }

    // const topId = this.scrollTopTarget?.id ?? null;
    // if (topId) {
    //   this.queryParams.start = topId;
    // }

    const queryParams = {
      ...this.queryParams,
      id: word.id,
      l: this.type,
    }
    this.router.navigate([this.thisPageAddr], {queryParams}).then();

    this.resetScroll();
  }


  /**
   * 단어 상세 팝업창을 닫을 때의 이벤트 처리 함수
   * 라우터 주소가 변경되어야하기 때문에 바로 CloseDetail()함수를 호출하지 않고 라우터를 통해서 CloseDetail()이 불려지도록 한다.
   * @protected
   */
  protected onCloseItem(bookmark: boolean | null = null): void {
    if (bookmark !== null && this.curDetail) {
      // 웹에서 불려진 경우.

      // 현재 책갈피 화면이라면, 닫을 때 해당 단어를 제거한다.
      if (this.ll instanceof WordBookmarkService && !bookmark) {
        this.bmSvc.hideBookmark(this.curDetail.id);
      }

      // 클로즈 버튼을 직접 눌렀을때만 수행
      // this.setHistory({start: this.curDetail.id}, false);
    }

    const queryParams = {
      ...this.queryParams,
      l: this.type,
    };
    delete queryParams.id;
    // if (this.curDetail?.id === queryParams.start) {
    //   delete queryParams.start;
    // }

    // console.warn('WordComponent::onCloseItem() queryParams =', queryParams, this.queryParams);
    this.router.navigate([this.thisPageAddr], {queryParams}).then();
  }


  /**
   * 단어 상세 보기
   * (1) 단어를 목록 상단으로 이동
   * (2) 상세 팝업창 열기
   *
   * @param $event - MouseEvent
   * @param word - 선택된 SimpleWord 객체
   */
  public OpenDetail(word: SimpleWord): void {
    // console.error("open detail");
    // 이미 열려있으면 무시
    if (this.showDetail) {
      console.warn('OpenDetail() already opened!');
      return;
    }

    this.showDetail = true;
    this.curDetail = word;

    timer(CONTAINER_SCROLL_DELAY).subscribe(() => {
      const el = document.getElementById(wordSelectId(word));
      if (el) {
        const elContainer = el.offsetParent as HTMLElement;
        if (elContainer !== this.container.nativeElement) {
          throw Error('HTML structure error');
        }

        const delta = this.deltaHeight;
        this.detailHeight = getDetailHeight(elContainer, el, this.footer.height + delta);
        this.oldScrollTop = scrollToNode(elContainer, el, - delta);
      }
      else {
        console.error(`document.getElementById(${wordSelectId(word)}) is null`);
      }
    });

    if (!(this.ll instanceof WordHistoryService)) {
      this.historySvc.addHistory(word.id);
    }
  }

  /**
   * 상세 단어장을 닫았을 때의 이벤트 처리 함수
   * @param bookmark - 닫은 단어의 북마크 상태
   */
  public CloseDetail(): void {
    console.log('WordComponent::CloseDetail()');
    if (this.curDetail) {
      this.curDetail = null;
    }

    if (this.lm.showHelp) {
      this.CloseWordHelp();
    }

    if (this.showDialectMap) { //만약 사투리 지도가 열려있을경우
      this.CloseDialectMap();
    }

    this.voice?.Stop();
    this.showDetail = false;
  }

  /****************************************************************************
   * 사투리 지도 찹업창 처리 코드
   ***************************************************************************/

  public onOpenMap(word: Word): void {
    this.curWord = word;
    this.showDialectMap = true;
  }

  public CloseDialectMap(): void {
    this.showDialectMap = false;
  }


  /****************************************************************************
   * 단어 도움말 팝업창 처리 코드
   ***************************************************************************/

  public OpenWordHelp(): void {
    this.voice.Stop();
    this.lm.showHelp = true;
  }

  public CloseWordHelp(showSaseung: boolean | null = null): void {
    this.lm.showHelp = false;

    if (showSaseung !== null) {
      this.option.showSaseung = showSaseung;
    }
  }

  public ClosePitchHelp(): void {
    this.lm.showPitchHelp = false;
  }

  /****************************************************************************
   * 스크롤시 상단 아이템 정보 얻어오기
   ***************************************************************************/
  private lastWordIndex: number | null = null;
  private lastScrollTop: number = 0;

  private get scrollTopTarget(): SimpleWord | undefined {
    const elContainer = this.container?.nativeElement;
    if (!elContainer) {
      return;
    }
    const words = this.ll.getList();
    if (!words || words.length === 0) {
      this.lastWordIndex = null;
      return;
    }

    const currentScrollTop = elContainer.scrollTop + this.header.height;
    // console.warn('scrollTopTarget:: currentScrollTop =', currentScrollTop, elContainer.scrollTop, this.header.height, this.header);

    // 스크롤 방향 확인
    let startIndex = this.lastWordIndex ?? 0;
    if (currentScrollTop > this.lastScrollTop && startIndex < words.length - 1) {
      startIndex++;
    } else if (currentScrollTop < this.lastScrollTop && startIndex > 0) {
      startIndex--;
    }

    let low = 0;
    let high = words.length - 1;
    let mid: number;
    let word: SimpleWord;

    while (low <= high) {
      mid = Math.floor((low + high) / 2);
      word = words[mid];

      if (word.offsetTop < currentScrollTop) {
        low = mid + 1;
      } else if (word.offsetTop > currentScrollTop) {
        high = mid - 1;
      } else {
        this.lastWordIndex = mid;
        this.lastScrollTop = currentScrollTop;
        return word;
      }
    }

    if (low < words.length) {
      this.lastWordIndex = low;
      this.lastScrollTop = currentScrollTop;
      return words[low];
    }

    this.lastScrollTop = currentScrollTop;
    this.lastWordIndex = null;
  }

}
